module.exports = __webpack_public_path__ + "img/christmas-toons.5dbd208d.jpg";